import { SettingHeader } from '@hive/component/setting-components';
import { useI18n } from '@hive/i18n';

import { list } from './index.css';
import { ReadwiseIntegration } from './readwise';

export const IntegrationSetting = () => {
  const t = useI18n();
  return (
    <>
      <SettingHeader
        title={t['com.hive.integration.integrations']()}
        subtitle={
          <>
            {t['com.hive.integration.setting.description']()}
            {/* <br /> */}
            {/* <a>{t['Learn how to develop a integration for Hive']()}</a> */}
          </>
        }
      />
      <ul className={list}>
        <ReadwiseIntegration />
      </ul>
    </>
  );
};
